/**
 * /canal (ES) and /channel (EN): only MuxVideoPlayerWithCTA → custom Stripe checkout.
 * No other content: video + CTA; mobile → /checkout-channel-invite, desktop → overlay.
 */

import { useEffect } from "react";
import MuxVideoPlayerWithCTA from "@/components/MuxVideoPlayerWithCTA";

export default function ChannelInviteLanding() {
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    const originalHeight = document.body.style.height;
    const originalPosition = document.body.style.position;
    document.body.style.overflow = "hidden";
    document.body.style.height = "100dvh";
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    return () => {
      document.body.style.overflow = originalOverflow;
      document.body.style.height = originalHeight;
      document.body.style.position = originalPosition;
      document.body.style.width = "";
    };
  }, []);

  return (
    <div
      className="fixed inset-0 z-0 flex items-stretch justify-center overflow-hidden bg-black"
      style={{ touchAction: "none", overscrollBehavior: "none" }}
    >
      <div
        className="relative h-full w-full overflow-hidden md:max-w-[430px]"
        style={{ maxHeight: "100dvh" }}
      >
        <MuxVideoPlayerWithCTA
          service="channel_invite"
          displayMode="reel"
          conversionReel={true}
          freeJoinCTA
        />
      </div>
    </div>
  );
}
